/**
 * FriendCard styles – composed from sub-files.
 * All sub-component style helpers are re-exported here for backward compat.
 */

import type { Theme } from '../../../src/theme/getTheme';
import type { ThemeMode } from '../../../src/theme/ThemeContext';
import { getFriendCardBaseStyles } from './FriendCardBase.styles';
import { getFriendCardAvatarStyles } from './FriendCardAvatar.styles';
import { getFriendCardStatsStyles } from './FriendCardStats.styles';
import { getFriendCardPendingStyles } from './FriendCardPending.styles';
import { getFriendCardBetsStyles } from './FriendCardBets.styles';

// Re-export all helpers so existing imports don't break
export { getCardDimensions, getCardContentStyle, getRemoveButtonStyle, getSelectionIndicatorStyle } from './FriendCardBase.styles';
export { getAvatarContainerStyle, getAvatarImageStyle, getGroupImageStyle, getStatusDotStyle, getProfileBadgeStyle, getRankCrestStyle, getRankLevelPillStyle } from './FriendCardAvatar.styles';
export {
  getWinRateCoinSubtitleStyles,
  getCoinBalanceRowStyles,
  getFriendNameStyle,
  getStatTextStyle,
} from './FriendCardStats.styles';

/**
 * Returns all FriendCard styles as a single merged object.
 * Spreads the sub-StyleSheet objects — each value is a processed style
 * (ID on native, style object on web) and works correctly as a style prop.
 */
export const getFriendCardStyles = (theme: Theme, themeMode?: ThemeMode) => ({
  ...getFriendCardBaseStyles(theme, themeMode),
  ...getFriendCardAvatarStyles(theme, themeMode),
  ...getFriendCardStatsStyles(theme, themeMode),
  ...getFriendCardPendingStyles(theme),
  ...getFriendCardBetsStyles(theme),
})
